import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { mdiBriefcasePlus, mdiArrowLeftCircle } from '@mdi/js';
import { useRouteMatch, Link, Redirect } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import Icon from '@mdi/react';
import PageTitle from '../../../components/PageTitle/PageTitle';
import AcquirerForm from '../AcquirerForm/AcquirerForm';
import { createAcquirer, startCreateAcquirer } from '../../../redux/modules/acquirers';

const AcquirerCreate = () => {
    const dispatch                         = useDispatch();
    const { path }                         = useRouteMatch();
    const { t }                            = useTranslation();
    const { acquirer, successfullyCreated } = useSelector(state => state.acquirers);

    useEffect(() => {
        dispatch(startCreateAcquirer());
    }, [dispatch]);

    if (successfullyCreated && acquirer) {
        return <Redirect to={ `edit/${acquirer.id}` } />
    }

    const actions = <Link to={ `${path.replace('new', '')}` }>
        <Button color="info">
            <Icon path={ mdiArrowLeftCircle } size={ 1 } color="white" /> { t('common.back') }
        </Button>
    </Link>;

    const handleAcquirerCreation = (values) => {
        dispatch(createAcquirer(values));
    };

    return (
        <div className="AcquirerCreate">
            <Row>
                <Col>
                    <PageTitle
                        title={ t('acquirers.add_title') }
                        icon={ <Icon path={mdiBriefcasePlus} color="white" /> }
                        actions={ actions }
                    />
                </Col>
            </Row>
            <Row>
                <Col xl={{ size: 4, offset: 4 }} md="6">
                    <AcquirerForm onSubmit={ handleAcquirerCreation } isCreation={ true } />
                </Col>
            </Row>
        </div>
    );
}

export default AcquirerCreate;
